<template>
  <div class="editor-container" :bob="componentKey" :key="componentKey">
    <v-toolbar class="editor-toolbar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Dock Menu</v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.breakpoint.smAndUp">
        <GlobalPlayNode v-if="this.EnableAll" :editor="myEditor" />
        <GlobalResetNodes v-if="this.EnableAll" :editor="myEditor" :sleepTime="1000"/>
        <v-btn icon @click.prevent="download()">
          <v-icon>fas fa-file-download</v-icon>
        </v-btn>
        <FileReader @load="loadedJsonFileData = $event" />

        <v-menu open-on-hover open-on-click bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item-group v-model="model1">
              <v-list-item v-for="(item, i) in items2" :disabled="!itemEnabled(item)" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="item"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </template>
    </v-toolbar>
    <div class="editor" id="rete" ref="rete"></div>
    <div class="dock"></div>

    <v-navigation-drawer app clipped v-model="drawer">
      <v-list dense>
        <v-list-item-group active-class="blue--text text--accent-4">
          <v-list-item
            v-for="item in items"
            :key="item.text"
            @click.prevent="changedock(item.operation)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import "vuetify/dist/vuetify.min.css";

import Rete from "rete";

import VueRenderPlugin from "rete-vue-render-plugin";
import ConnectionPlugin from "rete-connection-plugin";
import ContextMenuPlugin from "rete-context-menu-plugin";
import AreaPlugin from "rete-area-plugin";
import DockPlugin from "rete-dock-plugin";

import ReteComponentStore from "../components/ReteComponentStore.js";
import dataJson from "../assets/data.json";

import InMemoryStockData from "../Utils/InMemoryStockData.js";
import ApplStockCsv from "../assets/appl_stock.js";
import SnapStockCsv from "../assets/snap_stock.js";
import TslaStockCsv from "../assets/tsla_stock.js";

import FileReader from "../components/FileReader";
import GlobalResetNodes from "../components/GlobalResetNodes"
import GlobalPlayNode from "../components/GlobalPlayNode"

import DynamicDock from "../Utils/DynamicDock.js";
import ModuleStore from "../Utils/ExampleModules.js";
const fb = require("../firebaseConfig.js");
export default {
  name: "ReteEditor",
  components: {
    FileReader,
    GlobalResetNodes,
    GlobalPlayNode
  },
  data() {
    return {
      dockhelper: null,
      items: null,
      drawer: false,
      loadedJsonData: dataJson,
      appl: ApplStockCsv,
      snap: SnapStockCsv,
      tsla: TslaStockCsv,
      myEditor: null,
      loadedJsonFileData: "",
      model1: null,
      selectedModule: null,
      items2: [],
      componentKey1: 0,
      processing: false,
      EnableAll: false
    };
  },
  beforeMount() {
    console.log("beforeMount");
  },
  async beforeUpdate() {
    // console.log("beforeUpdate");
    //this.refresh();
    //  await this.createEditor();
    //     this.myEditor.view.resize();
    //  this.$forceUpdate();  // Notice we have to use a $ here
  },
  beforeCreate() {
    console.log("beforecreated");
  },
  created() {
    InMemoryStockData.loadSymbolCSV("appl", "APPLE", this.appl);
    InMemoryStockData.loadSymbolCSV("snap", "SNAP", this.snap);
    InMemoryStockData.loadSymbolCSV("tsla", "TESLA", this.tsla);
    console.log("created");
  },

  watch: {
    async loadedJsonFileData(val) {
      var data = JSON.parse(this.loadedJsonFileData);
      await this.loadStudyFromData(data);
    },
    async model1(newValue, old) {
      if (newValue == undefined && old == this.selectedModule) {
        this.selectedModule = old;
      } else {
        this.selectedModule = newValue;
      }
      let moduleKey = this.items2[this.selectedModule];
      let data = ModuleStore.getModuleByKey(moduleKey);
      await this.loadStudyFromData(data);
    }
  },

  computed: {
    componentKey() {
      console.log("KEY CHANGED" + this.$store.state.editorComponentKey);
      if (
        this.$store.state.editorComponentKey > 0 &&
        this.processing == false
      ) {
        console.log("KEY processing" + this.$store.state.editorComponentKey);
        this.processing = true;
          // setTimeout(() => (this.$router.go("/editor")), 300);
        
//      setTimeout("location.reload(true);",1000);

      }
      //     this.$forceUpdate();  // Notice we have to use a $ here
      return this.$store.state.editorComponentKey;
    }
  },
  methods: {
    itemEnabled(ix) {
      return this.EnableAll || ModuleStore.getModuleEnabledByKey(ix);
    },
    refresh(editorEnabled) {
      this.EnableAll = this.$store.state.currentUser != null && editorEnabled;
      ReteComponentStore.reset();
      ReteComponentStore.loadComponents(
        this.$store.state.currentUser != null && editorEnabled
      );

      this.dockhelper = new DynamicDock();
      this.items = this.loadNodeTypes();

      this.items2 = ModuleStore.getAllModulesKeys(
        this.$store.state.currentUser != null && editorEnabled
      );
    },
    forceRerender() {
      this.componentKey1 += 1;
    },
    updateEditorView(){
      setTimeout(()=>{
          AreaPlugin.zoomAt(this.myEditor, this.myEditor.nodes);
          for(var node in this.myEditor.nodes){
            var myNode = this.myEditor.nodes[node];
          this.myEditor.view.updateConnections( {node:myNode} )
          }
          },
          50)
    },
    async loadStudyFromData(data) {
      if (data !== null && data.id === "demo@0.1.0") {
        this.loadedJsonData = data;
        await this.myEditor.fromJSON(this.loadedJsonData);
        this.updateEditorView();
        
      }
    },
    changedock(op) {
      this.dockhelper.DisplayDock(ReteComponentStore.getNodeCategory(), op);
    },
    loadNodeTypes() {
      var ret = this.dockhelper.CreateDrawerItems(
        ReteComponentStore.getNodeCategory()
      );
      return ret;
    },
    download() {
      const data = JSON.stringify(this.myEditor.toJSON());
      const blob = new Blob([data], { type: "text/plain" });
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = "study.pi";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    },
    upload() {
      document.getElementById("file-input").click();
    },
    loadModule() {
      alert(this.model1);
    },
    async createEditor() {
      console.log("createEditor");
      var components = ReteComponentStore.get(),
        engine = new Rete.Engine("demo@0.1.0");
      const container = this.$refs.rete;
      const editor = new Rete.NodeEditor("demo@0.1.0", container);
      this.myEditor = editor;
      //Add plugins
      this.myEditor.use(ConnectionPlugin);
      this.myEditor.use(VueRenderPlugin);
      this.myEditor.use(ContextMenuPlugin);
      this.myEditor.on("showcontextmenu", ({ e, node }) => {
        // e - MouseEvent, node - Node instance or null
        return Boolean(node); // show context menu for nodes only
      });
      this.myEditor.use(AreaPlugin, { scaleExtent: { min: 0.2, max: 10 } });
      //Dock
      this.myEditor.use(DockPlugin, {
        container: document.querySelector(".dock"),
        //itemClass: "test",
        plugins: [VueRenderPlugin] // render plugins);
      });

      // Register components
      components.map(c => {
        this.myEditor.register(c);
        engine.register(c);
      });

      //load

      await this.loadStudyFromData(this.loadedJsonData);

      //Resize
      this.myEditor.view.resize();
      //    AreaPlugin.zoomAt(editor);
      AreaPlugin.zoomAt(editor, editor.nodes);

      // Add triggers
      this.myEditor.on(
        "process nodecreated noderemoved connectioncreated connectionremoved",
        async () => {
          await engine.abort();
          await engine.process(editor.toJSON());
        }
      );

      // force refresh
      this.myEditor.trigger("process");
    }
  },
  async mounted() {
    var ee = false;
    try {
      if (this.$store.state.currentUser !== null) {
        var res = await fb.usersCollection
          .doc(this.$store.state.currentUser.uid)
          .get();
        console.log("ee passed");
        ee = res.data().editorEnabled;
      }
    } catch (e) {
      console.log("ee failed" + e);
    } finally {
      this.refresh(ee);
      await this.createEditor();
    }
  }
};
</script>

<style>
.editor-container {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  height: 86.9vh;
}
.editor-toolbar {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  height: 50px;
}

.editor {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  height: 40vh;
}

.dock {
  height: 100px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.dock-item {
  display: inline-block;
  vertical-align: top;
  transform: scale(0.5);
  transform-origin: 50% 0;
}
.test {
  display: inline-block;
  vertical-align: top;
  transform: scale(0.5);
  transform-origin: 50% 0;
}
</style>
